/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1511
 */

module.exports = {
  input: "WidgetInput_input__1QQvg"
}
